import IProjectOutput from "@/api/models/IProjectOutput";
import formatDate from "@/helpers/formatDate";

export default function createProjectOutput(): IProjectOutput {
  return {
    id: "",
    name: "",
    icon: "",
    iconFile: null,
    postcode: "",
    address: "",
    latitude: 0,
    longitude: 0,
    start: formatDate(new Date()),
    end: "",
    note: "",
    state: 1,
    closed: false,
    templateId: 0,
    tgId: "",
    sSystemId: "",
    OHANo: "",
    holdOut: false,
    beforeTemplateId: 0,
    additionalProperties: [],
    taskDefaults: [],
    contractDate: "",
    created: formatDate(new Date()),
    constructionType: "",
    responsiblePerson: ""
  };
}
